export class IntlUtilsBase {
    constructor(config) {
        this.config = config;
        this.isLanguageValid = (target) => !!target && this.languages.includes(target);
        this.getLanguageWithFallback = (target) => this.isLanguageValid(target) ? target : this.config.defaultLanguage;
        this.languages = [config.defaultLanguage, ...config.otherLanguages];
    }
}
